import { __awaiter, __generator } from "tslib";
import create from 'zustand';
import { createErrorNotification, createLoadingNotification, createSuccessNotification, } from './actionCreators';
export var useToastStore = create(function (set) { return ({
    actionCreators: {
        clearNotification: function () {
            set({ toast: undefined });
        },
        createErrorNotification: function (message, actionButtonInfo) {
            set({ toast: createErrorNotification(message, actionButtonInfo) });
        },
        createLoadingNotification: function (message, actionButtonInfo) {
            set({
                toast: createLoadingNotification(message, actionButtonInfo),
            });
        },
        createSuccessNotification: function (message, actionButtonInfo) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                set({
                    toast: createSuccessNotification(message, actionButtonInfo),
                });
                return [2 /*return*/];
            });
        }); },
    },
    setToast: function (toast) { return set({ toast: toast }); },
    toast: undefined,
}); });
//# sourceMappingURL=store.js.map